function languageRedirect() {
  let languageSite = getCookie('lng') || (setCookie('lng', 'ua'), 'ua');
  if (document.body.classList.contains('ru') && location.pathname === '/' && languageSite === 'ua' &&
      !['pravo.', 'store.', 'ua-award.', 'services.', 'community.', 'academy.'].some(sub => location.hostname.includes(sub))) {
    redirectOtherLang();
  }
}

function redirectOtherLang() {
  let href = window.location.href;
  window.location.href = document.body.classList.contains('ru')
      ? href.replace(location.hostname, location.hostname + '/ua')
      : href.replace(location.hostname + '/ua', location.hostname);
}

function getCookie(name) {
  return document.cookie.split('; ').find(row => row.startsWith(name + '='))?.split('=')[1];
}

function setCookie(name, value) {
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/; expires=${new Date(Date.now() + 30758400000).toUTCString()}; domain=${location.hostname.split('.').slice(-2).join('.')}`;
}

function setEventSelectLang() {
  document.body.addEventListener('click', event => {
    let lang = event.target.getAttribute('data-lang');
    if (lang) setCookie('lng', lang);
  });
}

setEventSelectLang();
languageRedirect();